import { appConfig } from 'config/customization';

export default {
  container: {
    display: 'flex',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 45,
    alignItems: 'center',
    borderWidth: 0,
    textAlign: 'left'
  },
  activeItemIndicator: {
    borderLeftWidth: 5,
    borderColor: appConfig.colors.primary,
    borderStyle: 'solid',
    paddingLeft: 40
  },
  inactiveText: {
    color: appConfig.colors.inactiveText
  },
  activeText: {
    color: appConfig.colors.suboptionActiveText,
    textDecoration: 'none'
  },
  link: {
    textDecoration: 'none',
    outline: 'none'
  }
};
